import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Loader2, Users } from "lucide-react";
import { Button } from "./ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "./ui/dialog";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/private-docs/members`;

export const PrivateDocsMembers = () => {
  const [open, setOpen] = useState(false);
  const [data, setData] = useState(null);
  const [sel, setSel] = useState(new Set());
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (!open) return;
    setData(null);
    axios.get(API).then((r) => { setData(r.data); setSel(new Set(r.data.allowed)); }).catch(() => toast.error("تعذّر التحميل"));
  }, [open]);
  const toggle = (id) => setSel((p) => { const n = new Set(p); n.has(id) ? n.delete(id) : n.add(id); return n; });
  const save = async () => {
    setBusy(true);
    try { await axios.put(API, { user_ids: [...sel] }); toast.success("تم حفظ المستخدمين المسموح لهم"); setOpen(false); }
    catch (e) { toast.error(e?.response?.data?.detail || "تعذّر الحفظ"); } finally { setBusy(false); }
  };
  return (
    <>
      <Button size="sm" variant="outline" data-testid="private-members-open" onClick={() => setOpen(true)} className="gap-1.5"><Users className="h-4 w-4" /> المستخدمون المسموح لهم</Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="sm:max-w-md font-body max-h-[85vh] overflow-y-auto" dir="rtl" data-testid="private-members-dialog">
          <DialogHeader><DialogTitle>من يستطيع فتح الوثائق الخاصة؟</DialogTitle>
            <DialogDescription>كل مستخدم تختاره يضع رمزه السري الخاص أول مرة، وله نفس صلاحياتك (مشاهدة ورفع وتعديل وحذف).</DialogDescription></DialogHeader>
          {!data ? <div className="py-8 text-center"><Loader2 className="mx-auto h-5 w-5 animate-spin text-slate-400" /></div> : (
            <div className="space-y-1.5">
              {data.users.length === 0 && <p className="py-6 text-center text-sm text-slate-400">لا يوجد مستخدمون آخرون في الشركة</p>}
              {data.users.map((u) => (
                <label key={u.user_id} data-testid={`private-member-${u.user_id}`} className={`flex items-center justify-between gap-2 rounded-xl border px-3 py-2 cursor-pointer transition-colors ${sel.has(u.user_id) ? "border-emerald-300 bg-emerald-50" : "border-slate-200 hover:bg-slate-50"}`}>
                  <div className="min-w-0"><div className="text-sm font-semibold text-slate-800 truncate">{u.name || u.email || u.phone}</div>
                    <div className="text-[11px] text-slate-400 truncate" dir="ltr">{u.email || u.phone}{sel.has(u.user_id) && data.allowed.includes(u.user_id) ? (u.has_pin ? " · رمز مُعيّن" : " · لم يضع رمزه بعد") : ""}</div></div>
                  <input type="checkbox" checked={sel.has(u.user_id)} onChange={() => toggle(u.user_id)} className="h-4 w-4 accent-emerald-600" />
                </label>
              ))}
            </div>
          )}
          <DialogFooter className="flex-row-reverse gap-2 sm:justify-start">
            <Button data-testid="private-members-save" disabled={busy || !data} onClick={save} className="bg-slate-900 gap-1.5">{busy && <Loader2 className="h-4 w-4 animate-spin" />} حفظ</Button>
            <Button variant="outline" onClick={() => setOpen(false)}>إلغاء</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
};
